import { useContext } from 'react';
import ShopsContext, { IShopsContext } from 'dashboard/contexts/ShopsContext';

const useShops = (): IShopsContext => useContext(ShopsContext);

export default useShops;
